var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66671 11.3334V7.79171M8.50004 11.3334V5.66671M11.3334 11.3334V9.91671M12.75 2.83337H4.25004C3.87432 2.83337 3.51398 2.98263 3.24831 3.24831C2.98263 3.51398 2.83337 3.87432 2.83337 4.25004V12.75C2.83337 13.1257 2.98263 13.4861 3.24831 13.7518C3.51398 14.0175 3.87432 14.1667 4.25004 14.1667H12.75C13.1257 14.1667 13.4861 14.0175 13.7518 13.7518C14.0175 13.4861 14.1667 13.1257 14.1667 12.75V4.25004C14.1667 3.87432 14.0175 3.51398 13.7518 3.24831C13.4861 2.98263 13.1257 2.83337 12.75 2.83337Z",
    stroke: "#F45600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.218c518ac3cb4f7ca4ab380fcf49d5f5.svg";
export { ForwardRef as ReactComponent };